import React, { Component } from 'react';
import { connect } from 'react-redux';
import autobind from 'autobind-decorator';

import cordovaApp from 'core/cordova-app';
import config from 'config';

import { getCategory } from 'core/states/Category';
import { getCart } from 'content/pages/Cart/Module';
import { getAvailableOrder } from 'content/pages/OrderStep/Module';

import services from 'core/services';
import routes from 'core/router/index';
import { Layout } from 'core/layout';
import { Splash, Page, GroupBox } from 'core/components';
import { deviceToken, disableApp, enableApp, healthinfo, getNotification, getConfig, registrarion, openLinkInBrowser, versionCodeToVersionNumber } from 'core/module/operations';
import { Update, Info } from 'content/components';

import { App, Statusbar, CardContent, Popup } from 'core/components/Framework7';

import splashImage from '../../assets-src/cordova-splash-screen.png';

// const isCordova = process.env.TARGET == 'cordova'

class AppComponent extends Component {
	constructor(props) {
		super(props);

		// console.log("is cordova:", this.$device.cordova);

		// get statusbar computed background color from document stylesheet
		// const statusbarBgColor = getComputedStyle(document.documentElement).getPropertyValue('--f7-statusbar-bg-color').trim();
		// console.log('statusbarBgColor:', statusbarBgColor)

		this.state = {
			// Framework7 Parameters
			f7params: {
				...config.app.setting,
				// url: '/home',
				// App routes
				routes: routes,
				// Register service worker
				serviceWorker: this.$device.cordova ? {} : {
					path: './service-worker.js',
					scope: './',
				},
				// Input settings
				input: {
					scrollIntoViewOnFocus: this.$device.cordova && !this.$device.electron,
					scrollIntoViewCentered: this.$device.cordova && !this.$device.electron,
				},
				// Cordova Statusbar settings
				statusbar: {
					enabled: true,
					scrollTopOnClick: true,
					iosOverlaysWebView: true,
					androidOverlaysWebView: false,
					overlay: (this.$device.cordova && this.$device.ios) || 'auto',
					// iosBackgroundColor: statusbarBgColor,
					// androidBackgroundColor: statusbarBgColor,
				},
			},
			hasProblem: false,
			platform: "",
			serial: "",
			model: "",
			manufacturer: "",
			version: "",
			updateVersion: null,
			skipUpdate: false,
			showAttention: false,
			isCordova: process.env.TARGET == 'cordova',
		};
	};

	/**
	 * @inheritdoc
	 */
	componentDidMount() {
		this.$f7ready((f7) => {
			// Init cordova APIs (see cordova-app.js)
			if (f7.device.cordova) {
				cordovaApp.init(f7);
			}

			// Call F7 APIs here
			this.getInitData(f7)

			this.setState({ isCordova: f7.device.cordova })
		});
	};

	get data() {
		const { env } = this.props;

		return {
			page: env && env.pages && env.pages.attention,
		}
	}

	getInitData(f7) {
		// get health info
		this.getHealthInfo()
			.then(r => {
				// console.log("health info =>", r)
				// check | get token
				return this.checkToken()
			})
			.then(r => {
				// console.log("get config =>", r)
				return this.getConfig() //.catch(e => { throw 'get config failed' }),
			})
			.then(async r => {
				// get config
				return await Promise.all([
					this.getCartData(), //.catch(e => { throw 'get cart failed' }),
					this.getCategory(), //.catch(e => { throw 'get categories failed' }),
				])
			})
			.then(r => {
				if (f7.device.cordova) {
					// this.registerDeviceInfo()
					this.getNotification()
					this.registrarion()
				}

				// console.log("cart =>", r)
				// All done
				this.props.enableApp()

				setTimeout(() => {
					const statusbarBgColor = getComputedStyle(document.documentElement).getPropertyValue('--f7-statusbar-bg-color').trim();
					// console.log('time out statusbarBgColor:', statusbarBgColor)
					this.$f7.statusbar.setBackgroundColor(statusbarBgColor)
				}, 200)
			})
			.catch(e => {
				console.log("error =>", e)

				this.setState({
					hasProblem: true
				})
			})
	}

	getHealthInfo() {
		return new Promise((resolve, reject) => {
			this.props.healthinfo({ errorHandler: true })
				.then(r => {
					resolve(r)
				})
				.catch(e => {
					reject(e)
				})
		})
	}

	checkToken() {
		return new Promise((resolve, reject) => {
			const currentDeviceToken = services.storage.get('device_token')
			if (currentDeviceToken) {
				resolve(true)
			} else {
				services.storage.remove('customer_token')
				services.storage.remove('device_token')

				this.props.deviceToken()
					.then(r => {
						resolve(true)
					})
					.catch(e => {
						console.log("get token failed => ", e)
						reject(e)
					})
			}
		})
	}

	getConfig() {
		return new Promise((resolve, reject) => {
			// reject('get config error manual')
			this.props.getConfig()
				.then(r => {
					// console.log("check update =>", r)
					this.checkAttention(r)
					this.checkUpdate(r)

					if (process.env.NODE_ENV === 'production') {
						// head overwrite
						const html = (r && r.layout && r.layout.html) || {}
						const head = html.head || []
						const headEl = this.$$('head')
						head.map(rawEl => {
							headEl.append(rawEl)
						})
					}

					// this.setState((prevState) =>
					// 	(
					// 		{
					// 			f7params: {
					// 				...prevState.f7params,
					// 				statusbar: {
					// 					...prevState.f7params.statusbar,
					// 					iosBackgroundColor: statusbarBgColor,
					// 					androidBackgroundColor: statusbarBgColor
					// 				}
					// 			}
					// 		}
					// 	)
					// )
					// invalidate stylesheet variables
					// const styles = (r && r.layout && r.layout.styles) || {}
					// const urls = styles.urls || []
					// const overwrite = styles.overwrite
					// // console.log('r.styles:', r.styles)
					// // add stylesheet urls
					// urls.map(url => {
					// 	const linkEl = document.createElement('link')
					// 	linkEl.type = 'text/css'
					// 	linkEl.href = url
					// 	document.head.appendChild(linkEl)
					// })
					// // for (const key in styles) {
					// // 	// console.log('key:', key, ' - value:', styles[key])
					// // 	if (styles.hasOwnProperty(key))
					// // 		// document.documentElement.style.setProperty(key, styles[key])
					// // 		styleEl.style.setProperty(key, styles[key])
					// // }
					// // add overwrite
					// if (overwrite) {
					// 	const styleOverwriteEl = document.createElement('style')
					// 	// WebKit hack :(
					// 	styleOverwriteEl.appendChild(document.createTextNode(""));
					// 	styleOverwriteEl.innerHTML = overwrite
					// 	document.head.appendChild(styleOverwriteEl)
					// }

					resolve(r)
				})
				.catch(e => {
					// console.log("get config failed =>", e)
					reject(e)
				})
		})
	}

	getCartData() {
		return new Promise((resolve, reject) => {
			this.props.getCart({ store: 2 })
				.then(r => {
					this.getOrder(r)
					resolve(r)
				})
				.catch(e => {
					// console.log("get cart failed =>", e)
					reject(e)
				})
		})
	}

	getOrder(cart) {
		const orderId = cart.length > 0 && cart[0].orderId

		if (orderId) {
			this.props.getAvailableOrder(orderId)
		}
	}

	getCategory() {
		return new Promise((resolve, reject) => {
			const params = {
				store: 2
			}

			this.props.getCategory(params)
				.then(r => {
					resolve(r)
				})
				.catch(e => {
					reject(e)
				})
		})
	}

	checkAttention(env) {
		if (this.data.page && this.data.page.active) {
			this.setState({ showAttention: true })
		}
	}

	checkUpdate(env) {
		// console.log('env:', env, ', prop env:', this.props.env)
		var deviceInfo = services.storage.get('device_info');

		const currentVersionCode = deviceInfo && deviceInfo.appVersion
		const currentVersionNumber = versionCodeToVersionNumber(currentVersionCode);

		const latestVersion = this.handleAppCurrentVersion(env)
		const latestVersionCode = latestVersion && latestVersion.currentRelease

		// console.log(deviceInfo.appVersion, latestVersion, 'result:', (!currentVersionCode || !latestVersionCode || currentVersionCode >= latestVersionCode))

		if (!currentVersionCode || !latestVersionCode || currentVersionCode >= latestVersionCode) {
			this.setState({ skipUpdate: true })
			return
		}

		this.setState({
			updateVersion: {
				latestVersion: latestVersion,
				currentVersionNumber: currentVersionNumber,
			},
		})
	}

	handleAppCurrentVersion(env) {
		// const { env } = this.props;
		const platform = this.$device.cordova ? window.device.platform.toLowerCase() : 'pwa'
		// console.log('device:', this.$device.cordova, ', currentVersion:', env.apps.android.currentVersion)
		// console.log(String(window.device.platform).toLowerCase())
		// console.log('platform:', platform, ', app platform:', env.apps[platform].currentVersion, env && env.apps && env.apps[platform] && env.apps[platform].currentVersion)

		if (this.$device.cordova) {
			return env && env.apps && env.apps[platform] && env.apps[platform].currentVersion
			// switch (String(window.device.platform).toLowerCase()) {
			// 	case 'android':
			// 		return env && env.apps && env.apps.android && env.apps.android.currentVersion

			// 	case 'ios':
			// 		return env && env.apps && env.apps.ios && env.apps.ios.currentVersion

			// 	default:
			// 		return null
			// }
		}
	}

	registerDeviceInfo() {
		if (window.device) {
			this.setState({
				platform: window.device.platform,
				serial: window.device.serial,
				model: window.device.model,
				manufacturer: window.device.manufacturer,
				version: window.device.version,
			})

			if (this.state.platform) {
				services.storage.set("platform", this.state.platform)
			}

			if (this.state.serial) {
				services.storage.set("serial", this.state.serial)
			}

			if (this.state.model) {
				services.storage.set("model", this.state.model)
			}

			if (this.state.manufacturer) {
				services.storage.set("manufacturer", this.state.manufacturer)
			}

			if (this.state.version) {
				services.storage.set("version", this.state.version)
			}
		}
	}

	registrarion() {
		this.props.registrarion()
	}

	getNotification() {
		// console.log(window.FirebasePlugin)
		if (!window.FirebasePlugin) return

		window.FirebasePlugin.grantPermission(hasPermission => {
			console.log("Firebase permission was " + (hasPermission ? "granted" : "denied"));
		});

		window.FirebasePlugin.hasPermission(hasPermission => {
			console.log("Permission is " + (hasPermission ? "granted" : "denied"));
		});

		window.FirebasePlugin.subscribe("latest_news");

		window.FirebasePlugin.getToken(token => {
			// save this server-side and use it to push notifications to this device
			const fcmStorageToken = services.storage.get('fcm-token');

			if (fcmStorageToken && fcmStorageToken === token) return

			this.props.getNotification(token)
				.then(r => {
					// console.log('getNotification:', token)
				})
				.catch(err => {

				});
		}, function (error) {
			console.log('get fcm token error:', error)
		});

		window.FirebasePlugin.onTokenRefresh(token => {
			// save this server-side and use it to push notifications to this device
			const fcmStorageToken = services.storage.get('fcm-token');

			if (fcmStorageToken && fcmStorageToken === token) return

			this.props.getNotification(token)
				.then(r => { })
				.catch(err => {

				});
		}, function (error) {
			console.log('get fcm token error:', error)
		});
	}

	render() {
		const { appReady, env } = this.props;
		const { f7params, hasProblem, skipUpdate, updateVersion, showAttention } = this.state;
		// const storeClosed = env && env.store && env.store.closed
		// console.log('cordova:', this.state.isCordova)
		// console.log('App props:', this.props)
		// console.log('env:', env)
		// console.log('store closed:', storeClosed)

		return (
			<App params={f7params}>
				{appReady ?
					<React.Fragment>
						{this.$device.cordova && <Statusbar />}
						{skipUpdate ?
							<React.Fragment>
								<Layout />
								{/* Popup attention */}
								<Popup
									closeByOutsideClick
									tabletFullscreen
									opened={showAttention}
									onPopupClosed={() => this.setState({ showAttention: false })}
								>
									<Page
										showBack={false}
										showClose
										closePopup
										background={'page-update'}
									>
										{this.data.page.description && this.data.page.description.length > 0 &&
											<GroupBox outline title={'توجه!'}>
												<CardContent>
													{this.data.page && this.data.page.description && this.data.page.description.map((text, index) => {
														return <p key={index} style={{ textAlign: 'center', fontWeight: 'bold', margin: (this.data.page.description.length - 1 === index) ? '0' : '0 0 0.5em 0' }}>{text}</p>
													})}
												</CardContent>
											</GroupBox>
										}
									</Page>
								</Popup>
							</React.Fragment>
							:
							<Page
								title={'بروزرسانی اپلیکیشن'}
								showBack={false}
								background={'page-update'}
							>
								<Update
									updateVersion={updateVersion}
									onSkipUpdate={() => this.setState({ skipUpdate: true })}
								/>
							</Page>
						}
					</React.Fragment>
					:
					<Splash src={splashImage} hasProblem={hasProblem} />
				}
			</App>
		);
	};
};

export default connect(
	state => ({
		appReady: state.General.appReady,
		health: state.General.health,
		env: state.General.env,
		order: state.Order.order,
		price: state.Order.price,
	}),
	{
		getCategory,
		getCart,
		getAvailableOrder,
		deviceToken,
		disableApp,
		enableApp,
		healthinfo,
		getNotification,
		getConfig,
		registrarion,
		openLinkInBrowser,
	}
)(autobind(AppComponent));
